import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import Router from '@/routes/Router.tsx';
import { RouterProvider } from 'react-router-dom';
import {
  ENABLE_REACT_QUERY_DEV_TOOL,
  GOOGLE_OATUH_CLIENT_ID,
  POSTHOG_HOST,
  POSTHOG_KEY,
} from '@/lib/constants';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/sonner';
import ErrorBoundary from '@/components/layout/error-boundary';
import { queryClient } from '@/config/react-query';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { PostHogProvider } from 'posthog-js/react';
import { setupSentry } from '@/config/sentry/config';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useMarkerIo } from './hooks/use-markerio';

import './index.css';

const posthogOptions = {
  api_host: POSTHOG_HOST,
};

setupSentry();

export const App = () => {
  useMarkerIo();

  return (
    <StrictMode>
      <ErrorBoundary>
        <PostHogProvider apiKey={POSTHOG_KEY} options={posthogOptions}>
          <GoogleOAuthProvider clientId={GOOGLE_OATUH_CLIENT_ID}>
            <HelmetProvider>
              <QueryClientProvider client={queryClient}>
                {ENABLE_REACT_QUERY_DEV_TOOL ? <ReactQueryDevtools /> : null}
                <RouterProvider router={Router} />
                <Toaster />
              </QueryClientProvider>
            </HelmetProvider>
          </GoogleOAuthProvider>
        </PostHogProvider>
      </ErrorBoundary>
    </StrictMode>
  );
};

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
